var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CRow',[_c('CCol',[(_vm.entity)?_c('CCard',[_c('CCardHeader',[_c('strong',[_vm._v(_vm._s(_vm.entity.title))])]),_c('CCardBody',[_c('GrocerTabLinks'),_c('ImportPage',{attrs:{"id":_vm.entity.id,"type":"grocery"}})],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }